import { CSSProperties } from 'react';

// The Morning Brief hero headline (Figma 13517:97119). The teaser is dynamic prose, so the
// serif accent is placed by POSITION rather than by `**` markers: the SECOND word and the
// SECOND-TO-LAST word take the serif (Tinos) accent, the rest stay in the base sans (Archivo).
// The rule is language-agnostic (positional), so it holds whatever language the brief is in.
//
// (The fixed activate-state headline keeps `**`-marker styling — a translator marks the accent
// word there, which survives word-order changes a positional rule would not; see `BriefHeadline`.)

export function BriefHeadlinePositional({ text, accentStyle }: { text: string; accentStyle: CSSProperties }) {
  // Drop any `**` emphasis the teaser carried — the accent is positional here, not marker-based.
  const parts = text.replace(/\*\*/g, '').split(/(\s+)/);
  const wordCount = parts.filter((p) => /\S/.test(p)).length;
  const accentAt = new Set([1, wordCount - 2]); // 2nd word and 2nd-to-last (may coincide on 3-word lines)

  let word = -1;
  return (
    <>
      {parts.map((part, i) => {
        if (!/\S/.test(part)) return <span key={i}>{part}</span>;
        word += 1;
        return (
          <span key={i} style={accentAt.has(word) ? accentStyle : undefined}>
            {part}
          </span>
        );
      })}
    </>
  );
}
